module.exports = __webpack_public_path__ + "img/deleteBtn.6aebd686.svg";